<template>
  <div class="yxtbiz-rank-list__row-item flex align-items-center">
    <!-- 名次 -->
    <div
      v-if="rowData.rankOrder && rowData.rankOrder < 4"
      class="yxtbiz-rank-list__row-item-order"
    >
      <yxt-svg
        width="24px"
        height="24px"
        :remote-url="sspSvgCdn"
        :icon-class="'rank_no' + rowData.rankOrder"
      />
    </div>
    <div
      v-else
      class="
        standard-size-16
        text-8c
        yxtbiz-rank-list__row-item-order
        yxtf-weight-6
      "
    >
      {{ rowData.rankOrder }}
    </div>
    <!-- 头像 -->
    <div
      v-if="contentObj.hasHead"
      class="pr16 flex"
      :class="disabledSkip ? 'cursor-default' : 'cursor-point'"
      @click="!disabledSkip && linkToUserIndex(rowData.userId)"
    >
      <yxtf-portrait
        v-if="contentObj.objectCode === dictionaryKeys.user"
        size="48px"
        :img-url="rowData[dictionaryKeys.userImgUrl]"
        :username="rowData[dictionaryKeys.userName] || ''"
      />
      <div
        v-else
        class="yxtbiz-rank-list__row-item-dept-icon"
        :class="[
          rowData.rankOrder < 4
            ? 'yxtbiz-rank-list__row-item-dept-icon' + rowData.rankOrder
            : ''
        ]"
      >
        <yxtf-svg width="28px" height="28px" icon-class="department" />
      </div>
    </div>
    <!-- 姓名、部门、平台等 -->
    <div
      class="flex-1 yxtbiz-rank-list__row-item-content"
      :class="disabledSkip ? 'cursor-default' : 'cursor-point'"
      @click="!disabledSkip && linkToUserIndex(rowData.userId)"
    >
      <!-- 主要显示的内容 -->
      <primary-content
        v-if="contentObj.primaryCode"
        class="font-size-14 yxtf-weight-6"
        :code="contentObj.primaryCode"
        :name="rowData[contentObj.primaryCode]"
      />
      <!-- 次要显示的内容 -->
      <secondary-content
        v-if="contentObj.secondaryCodes && contentObj.secondaryCodes.length"
        :codes="contentObj.secondaryCodes"
        :contents="rowData"
        class="text-8c"
      />
    </div>
    <!-- 属性对应的值 -->
    <div
      v-if="contentObj.attributeCode"
      class="
        standard-size-14
        text-59
        ml24
        yxtbiz-rank-list__row-item-attribute-content
      "
    >
      {{ numberUnit(rowData.rankValue) }}
    </div>
    <div
      v-if="styleObject.styleType === 2"
      class="
        ml12
        standard-size-14
        text-8c
        flex
        yxtbiz-rank-list__row-item-attribute-name
      "
    >
      <yxt-tooltip
        effect="light"
        open-filter
        placement="top"
        :content="
          $t(contentObj.attributeName) +
          (contentObj.attributeCode === 'learningTime' ? '(min)' : '')
        "
      >
        <div class="ellipsis flex-1">
          {{ $t(contentObj.attributeName) }}
        </div>
      </yxt-tooltip>
      <div v-if="contentObj.attributeCode === 'learningTime'">(min)</div>
    </div>
  </div>
</template>
<script>
import {
  sspSvgCdn,
  dictionaryKeys,
  linkToUserIndex,
  numberUnit
} from '../config';
import primaryContent from './primaryContent.vue';
import secondaryContent from './secondaryContent.vue';
export default {
  components: {
    secondaryContent,
    primaryContent
  },
  props: {
    // 单行数据
    rowData: {
      type: Object,
      default: () => {}
    }
  },
  inject: ['contentFun', 'styleFun'],
  data() {
    return {
      sspSvgCdn,
      dictionaryKeys,
      linkToUserIndex,
      numberUnit
    };
  },
  computed: {
    // 当前数据里的机构不是用户所登录的机构/榜单的对象不是学员,不能跳转用户中心
    disabledSkip() {
      return (
        (this.rowData.orgId && this.rowData.orgId !== localStorage.orgId) ||
        this.contentObj.objectCode !== this.dictionaryKeys.user
      );
    },
    // 显示内容数据
    contentObj() {
      return this.contentFun();
    },
    // styleType 样式类型: 1 一列式、2 两列式, showStyle 展示样式: 1 列表式、2 横排式
    styleObject() {
      return this.styleFun();
    }
  }
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
